<script setup lang="ts">
import { ref } from 'vue'
import { InfoCircleIcon } from 'front-library'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps<{
  data: any
}>()

const openWindow = ref<boolean>(false)
const position = ref({
  x: 0,
  y: 0
})

const mouseenter = (e: any) => {
  if (openWindow.value) {
    return
  }
  position.value = {
    x: e.pageX,
    y: e.pageY
  }
  openWindow.value = true
}

const mouseleave = () => {
  if (!openWindow.value) {
    return
  }
  openWindow.value = false
}
</script>
<template>
  <div @click="mouseenter">
    <InfoCircleIcon
      class="cursor-pointer"
      :class="[
        props.data.error || props.data.errors ? 'text-red-500' : 'text-gray-500'
      ]"></InfoCircleIcon>
    <div class="relative">
      <Teleport to="body">
        <div
          v-if="openWindow"
          @mouseleave="mouseleave"
          class="info-icon-open bg-white border border-gray-200 rounded-xl shadow-xl outline-none"
          :style="{
            top: position?.y - 20 + 'px',
            left: position?.x - 20 + 'px'
          }">
          <div
            class="w-96 overflow-auto p-5 scroll"
            :class="[!props.data?.average ? 'max-h-56' : 'max-h-max']">
            <div v-if="props.data?.errors">
              <h1 class="title-info">{{ t('payrollSheet.list.mistakes') }}</h1>
              <div class="mb-3">
                <ul
                  class="list-inside ..."
                  v-for="(value, index) in props.data.errors"
                  :key="index">
                  <li
                    class="overflow-hidden whitespace-break-spaces text-red-500 text-sm text-justify">
                    {{ Object.entries(value)[0][0] }}:
                    {{ Object.entries(value)[0][1] }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="props.data?.error">
              <h1 class="title-info">{{ t('payrollSheet.list.error') }}</h1>
              <div
                class="overflow-hidden whitespace-break-spaces text-red-500 text-sm text-justify mb-2">
                {{ props.data?.error }}
              </div>
            </div>
            <div v-if="props.data?.evalQuantity">
              <h1 class="title-info">{{ t('payrollSheet.list.quantity') }}</h1>
              <div class="description-quantity-amount">
                {{ props.data?.evalQuantity }}
              </div>
            </div>
            <div v-if="props.data?.evalAmount">
              <h1 class="title-info">{{ t('payrollSheet.list.amount') }}</h1>
              <div class="description-quantity-amount">
                {{ props.data?.evalAmount }}
              </div>
            </div>
            <div v-if="props.data?.average">
              <table class="table w-full rounded-md overflow-hidden mb-2">
                <thead class="bg-gray-300">
                  <tr class="text-gray-500 text-sm text-left">
                    <td
                      class="px-3"
                      v-for="(row, index) in props?.data?.average?.historic
                        ?.header"
                      :key="index">
                      {{ row.title }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="text-left text-sm"
                    :class="[
                      item['applied'] === true || item['applied'] === undefined
                        ? 'bg-gray-100 border-gray-300 border-b-2 text-gray-500'
                        : 'border-gray-200 border-b-2 text-gray-400'
                    ]"
                    v-for="(item, index) in props?.data?.average?.historic
                      ?.rows"
                    :key="index">
                    <td
                      class="px-3"
                      v-for="(header, index) in props?.data?.average?.historic
                        ?.header"
                      :key="index">
                      {{ item[header.key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h1 class="title-info">{{ t('payrollSheet.list.average') }}</h1>
              <div class="description-quantity-amount">
                {{ props.data?.average.result }}
              </div>
            </div>
          </div>
        </div>
      </Teleport>
    </div>
  </div>
</template>
<style scoped>
.info-icon-open {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}

.title-info {
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 8px;
}
.description-quantity-amount {
  background-color: #f3f4f6;
  padding: 4px 8px;
  border-radius: 8px;
  color: #b91c1c;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  margin-bottom: 10px;
}
</style>
